import type {Module} from "vuex";
import type {RootState} from "@/store/types";
import {platform} from "@/api/platform";
import {retryRequest} from "@/helpers/request";
import emitter from "@/api/events";

// Ordering constraints of the user (limits per product type etc.), as delivered by the platform
export type Constraints = Record<string, unknown>

export interface ConstraintsState {
    loading: boolean
    type: Constraints | null
    cart: Constraints | null
}

const constraints: Module<ConstraintsState, RootState> = {
    namespaced: true,
    state: {
        loading: false,
        type: null,
        cart: null
    },
    getters: {
        loading: (state): boolean => state.loading,
        // Deep copies, so callers cannot change the state
        type: (state): Constraints | null => JSON.parse(JSON.stringify(state.type)),
        cart: (state): Constraints | null => null !== state.cart ? JSON.parse(JSON.stringify(state.cart)) : JSON.parse(JSON.stringify(state.type))
    },
    mutations: {
        setLoading: (state, loading: boolean) => state.loading = loading,
        setType: (state, type: Constraints | null) => state.type = type,
        setCart: (state, type: Constraints | null) => state.cart = type,
    },
    actions: {
        fetch(context) {

            context.commit("setLoading", true);

            return retryRequest(() => platform.get<{results: {constraints: {type: Constraints}}}>(`/api/v2/user/${this.getters["user/id"]}/constraints`))
                .then(response => {

                    context.commit("setType", response.data.results.constraints.type);
                    context.commit("setLoading", false);

                    emitter.emit('user_constraints_fetch');
                });
        },
        fetchCart(context) {

            context.commit("setLoading", true);

            const opts = {params: {useCart: true}};

            return retryRequest(() => platform.get<{results: {constraints: {type: Constraints}}}>(`/api/v2/user/${this.getters["user/id"]}/constraints`, opts))
                .then(response => {

                    context.commit("setCart", response.data.results.constraints.type);
                    context.commit("setLoading", false);

                    emitter.emit('user_constraints_fetch_cart');
                });
        },
        clear(context) {

            context.commit("setType", null);
            context.commit("setCart", null);
        }
    }
}

export default constraints
